import { config as appConfig } from "/app.config"
import { PODCAST_CATEGORIES } from "@/common/constants/podcastCategories"

export const podcasts = (state) => state.podcasts

export const botPodcasts = (state) => {
  if (state.podcasts === null) return null
  return state.podcasts.filter((p) => p.podcast_type === "recording_with_ai")
}

export const botPodcastCount = (state, getters) => {
  if (getters.botPodcasts === null) return null
  return getters.botPodcasts.length
}

export const podcast = (state) => state.podcast

export const isAiPodcast = (state) => state.podcast?.podcast_type === "recording_with_ai"

// The Access section of the podcast settings (geo and IP blocking) needs one of the two flags. A podcast with an
// external RSS feed gets it too: it can still have episodes that we host and deliver (recordings from the stream,
// episodes from before it moved to the feed), and a rule applies to those.
export const isAccessSectionAvailable = (state, getters, rootState, rootGetters) => {
  return rootGetters["FeatureFlags/isGeoBlockingAllowed"] || rootGetters["FeatureFlags/isIpBlockingAllowed"]
}

export const podcastCategories = () => PODCAST_CATEGORIES

export const podcastRSSLink = (state) => {
  if (!state.podcast.key) {
    return ""
  }

  return appConfig.podcastFeedURL + state.podcast.key + "/rss"
}
